import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumOutletRatingExclusions implements BaseEnumType {
  private static allValues: EnumOutletRatingExclusions[] = []; // make sure this is top-most
  
  public static includedOnly = new EnumOutletRatingExclusions(1, "IncludedOnly", "enum_outlet_rating_exclusions_included_only");
  public static excludedOnly = new EnumOutletRatingExclusions(2, "ExcludedOnly", "enum_outlet_rating_exclusions_excluded_only");
  public static all = new EnumOutletRatingExclusions(3, "All", "enum_outlet_rating_exclusions_all");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumOutletRatingExclusions.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isIncludedOnly() { return this === EnumOutletRatingExclusions.includedOnly; }
  public isExcludedOnly() { return this === EnumOutletRatingExclusions.excludedOnly; }
  public isAll() { return this === EnumOutletRatingExclusions.all; }

  public static getValues(): readonly EnumOutletRatingExclusions[] {
    return EnumOutletRatingExclusions.allValues;
  }

  public static getValuesExcept0(): readonly EnumOutletRatingExclusions[] {
    return EnumOutletRatingExclusions.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumOutletRatingExclusions {
    const found = EnumOutletRatingExclusions.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumOutletRatingExclusions - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumOutletRatingExclusions): EnumOutletRatingExclusions {
    const found = name ? EnumOutletRatingExclusions.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumOutletRatingExclusions - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumOutletRatingExclusions>): boolean {
    return this.key === other?.key;
  }
}